import InvalidContentIcon from '@mui/icons-material/BrokenImage';
import { Box, Typography } from '@mui/material';
import { useEffect } from 'react';

interface Props {
  onMount: () => void;
}

export function InvalidPresetContent({ onMount }: Props) {
  useEffect(() => {
    onMount();
  }, [onMount]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <InvalidContentIcon sx={{ width: 48, height: 48 }} color="error" />
      <Typography color="error" align="center">
        Preset has invalid content. Please ask the person who shared it to
        create a new one
      </Typography>
    </Box>
  );
}
